import { Button, Checkbox, Col, Form, Input, Modal, Row, useModalForm } from "@pankod/refine-antd";
import { ICompany, InputValidatorRegex } from "interfaces/company";
import { useEffect, useState } from "react";
import { urlPath } from "utility/url";
import type { CheckboxChangeEvent } from 'antd/es/checkbox';

export const IndusIndCompanyMappingComponent: React.FC<{
    refetchCompanyDetail: any,
    company: ICompany | undefined,
}> = ({ refetchCompanyDetail, company }) => {
    let url = urlPath();
    const [removeIndusIndMappingAfterCrnUpdate, setRemoveIndusIndMappingAfterCrnUpdate] = useState(false);

    const { modalProps, formProps, show: showIndusIndCompanyMappingModal, close: closeModal } = useModalForm<any>({
        resource: 'saveIndusIndCompanyMapping',
        dataProviderName: "grapghQl",
        action: "create",
        metaData: {
            companyId: url.lastElement,
            removeIndusIndMappingAfterCrnUpdate,
        },
        redirect: false,
        onMutationSuccess(data, variables, context) {
            refetchCompanyDetail(true);
            formProps.form?.resetFields();
        }
    });
    modalProps.title = `Company Mapping Details`;
    modalProps.centered = true;
    modalProps.width = 600;
    modalProps.onCancel = () => {
        formProps.form?.resetFields();
        setRemoveIndusIndMappingAfterCrnUpdate(false);
        closeModal();
    }

    useEffect(() => {
        if (modalProps.visible) {
            setRemoveIndusIndMappingAfterCrnUpdate(false);
            formProps.form?.setFieldsValue({
                removeIndusIndMappingAfterCrnUpdate,
                corporateRelationshipNo: company?.indusindMapping?.corporateRelationshipNo || '',
                authorisedSignatoryEmail: company?.indusindMapping?.authorisedSignatoryEmail || '',
            });
        }
    }, [modalProps.visible]);

    return (
        <>
            {
                <Button onClick={() => { showIndusIndCompanyMappingModal(); }} type="default">
                    Mapping Details
                </Button>
            }
            <Modal {...modalProps}>
                <Form
                    {...formProps}
                    name="mappingDetails"
                    layout="vertical"
                    // initialValues={
                    //     {
                    //         corporateRelationshipNo: company?.indusindMapping?.corporateRelationshipNo || '',
                    //         authorisedSignatoryEmail: company?.indusindMapping?.authorisedSignatoryEmail || '',
                    //         removeIndusIndMappingAfterCrnUpdate,
                    //     }
                    // }
                >
                    <Row gutter={16}>
                        <Col lg={12}>
                            <Form.Item className="w-100" rules={[
                                {
                                    message: 'Enter correct value',
                                    pattern: InputValidatorRegex.ALPHA_NUMERIC_WT_SPACE,
                                },
                                {
                                    message: 'Corporate Relationship No',
                                    required: true,
                                },
                            ]} label="Corporate Relationship No" name="corporateRelationshipNo">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col lg={12}>
                            <Form.Item label="Authorised Signatory Email" rules={[
                                {
                                    message: 'Enter a valid email',
                                    pattern: InputValidatorRegex.EMAIL,
                                },
                                {
                                    message: 'Authorised Signatory Email',
                                    required: true,
                                },
                            ]} className="w-100" name="authorisedSignatoryEmail">
                                <Input />
                            </Form.Item>
                        </Col>

                    </Row>
                    <Row gutter={16}>
                        <Col lg={24}>
                            <Checkbox checked={removeIndusIndMappingAfterCrnUpdate} onChange={(e: CheckboxChangeEvent) => { setRemoveIndusIndMappingAfterCrnUpdate(e.target.checked) }} name="removeIndusIndMappingAfterCrnUpdate">
                                Remove previous IndusInd mapping with this CRN
                            </Checkbox>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </>
    );
}